import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ZoomHelperService{
    public zoomLevel: number;
    public hasZoomChanged: boolean = false;
    public maxZoomLevel: number = 4;
    public minZoomLevel: number = 1;

    public getDistance(touch1: Touch, touch2: Touch): number {
        const dx = touch1.pageX - touch2.pageX;
        const dy = touch1.pageY - touch2.pageY;
        return Math.sqrt(dx * dx + dy * dy);
      }
    
    // Helper method to calculate the midpoint between two touch points using page coordinates
    public getMidpoint(touch1: Touch, touch2: Touch): { x: number, y: number } {
    return {
        x: (touch1.pageX + touch2.pageX) / 2,
        y: (touch1.pageY + touch2.pageY) / 2,
    };
    }

    public calculateTransformOrigin(rect: DOMRect, midpoint: { x: number, y: number }): { originX: number, originY: number } {
        const elementPageX = rect.left + window.scrollX;
        const elementPageY = rect.top + window.scrollY;
        const focalX = midpoint.x - elementPageX;
        const focalY = midpoint.y - elementPageY;
        let originX = (focalX / rect.width) * 100;
        let originY = (focalY / rect.height) * 100;
        originX = Math.max(0, Math.min(100, originX));
        originY = Math.max(0, Math.min(100, originY));
        return { originX, originY };
    }

    public getZoomLevel(): number {
        return this.zoomLevel;
    }

    public setZoomLevel(zoomLevel: number): void {
        this.zoomLevel = zoomLevel;
    }

    public setHasZoomChanged(hasZoomChanged: boolean): boolean {
        this.hasZoomChanged = hasZoomChanged;
        return this.hasZoomChanged;
    }

    public getHasZoomChanged(): boolean {
        return this.hasZoomChanged;
    }
}
